import { ExternalEvidence } from '../../releases/ExternalEvidence';
import { Link } from 'react-router';
import type { TicketDetail } from '../../../api/ticket-types';
import { Badge, StateBadge, humanize } from '../../../ui/Badge';
import { Card } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';

export function Delivery({ t }: { t: TicketDetail }) {
  return (
    <Card
      title="Releases and delivery"
      subtitle="Reported results come from external executors. Verified results add an admin decision."
    >
      {t.releases.length === 0 ? (
        <span className="small muted">Not included in a release.</span>
      ) : (
        <ul className="checklist">
          {t.releases.map((r) => (
            <li key={r.id} style={{ justifyContent: 'space-between' }}>
              <Link to={`/projects/${t.project.key}/releases/${r.displayId}`}>
                <span className="mono">{r.displayId}</span> {r.title}
              </Link>
              <span className="row nowrap">
                <StateBadge state={r.state} />
                {r.reserved && (
                  <Badge tone="info" dot={false}>
                    Reserved
                  </Badge>
                )}
              </span>
            </li>
          ))}
        </ul>
      )}
      {t.externalDeliveries?.map((d) => (
        <div key={d.id} className="stack sm">
          <Link to={`/projects/${t.project.key}/releases/${d.releaseDisplayId}`}>
            {d.releaseDisplayId} · Accepted existing deployment
          </Link>
          <span className="small">
            Verified by admin review. Recorded <Timestamp value={d.recordedAt} />.
          </span>
          <ExternalEvidence evidence={d.evidence} />
        </div>
      ))}
      {t.deliveries.length > 0 && (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Attempt</th>
                <th>Kind</th>
                <th>State</th>
                <th>Provenance</th>
                <th>Registered</th>
              </tr>
            </thead>
            <tbody>
              {t.deliveries.map((d) => (
                <tr key={d.id}>
                  <td>
                    <Link
                      to={`/projects/${t.project.key}/releases/${d.releaseDisplayId}/attempts/ATT-${d.number}`}
                      className="mono"
                    >
                      {d.releaseDisplayId} · ATT-{d.number}
                    </Link>
                  </td>
                  <td>{humanize(d.kind)}</td>
                  <td>
                    <StateBadge state={d.state} />
                  </td>
                  <td>{d.provenance ? <StateBadge state={d.provenance} /> : '—'}</td>
                  <td className="small">
                    <Timestamp value={d.registeredAt} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
